// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "e7ad493c74f4a9fc8295fbe935b3d9707160574d/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"21":"36bf3700","98":"aa14b4c2","130":"3099d24f","440":"486bdddc","581":"a474c96c","731":"e6a68377","822":"5ed7a9db"}[chunkId] + ".chunk.js";
};